import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Jumpbotron = ({
  paths,
  titleBlack,
  titleRed,
  subTitle,
  //   children, //component has btn?children will become the btn
}) => {
  return (
    <div className="jumpbotron d-justify-center">
      <div className="rd--jumpbotron content-grilla">
        <ul>
          {paths.map((currentPath, index) => (
            <li key={index}>{currentPath}</li>
          ))}
        </ul>
        <h1 className="title-03">
          {titleBlack} <span className="title-red">{titleRed}</span>
        </h1>
        <p className="paragraph paragraph-16 margin-top-16">{subTitle}</p>
      </div>
    </div>
  );
};

Jumpbotron.propTypes = {
  actualPath: PropTypes.string,
  titleBlack: PropTypes.string,
  titleRed: PropTypes.string,
  subTitle: PropTypes.string,
  //   children: PropTypes.node,
};

Jumpbotron.defaultProps = {
  actualPath: "",
  titleBlack: "Welcome",
  titleRed: "User",
  subTitle: "",
};

export default Jumpbotron;
